import _extends from "@babel/runtime/helpers/extends";
import "core-js/modules/web.timers.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.function.name.js";
/**
 * 基础 fetch，返回结果包括 code message 和 result
 * @param url api 地址
 * @param option 配置参数
 * @return {Promise} 请求 Promise
 */
var fetchBase = function fetchBase(url, option) {
  var controller;
  var signal;
  var timeout = option.timeout;
  if (window.AbortController) {
    controller = new AbortController();
    signal = controller.signal;
  }
  // 在指定的时间后中止请求
  var timeoutId = setTimeout(function () {
    controller && controller.abort();
  }, timeout);
  // eslint-disable-next-line compat/compat
  return fetch(url, _extends({
    method: 'POST'
  }, option, {
    signal: signal
  })).then(function (resp) {
    if (resp.status !== 200) {
      throw resp;
    } else {
      return resp.json ? resp.json() : resp;
    }
  }).then(function (resp) {
    clearTimeout(timeoutId);
    if (typeof resp.code !== 'undefined' && resp.code !== 200) {
      throw resp;
    }
    return resp;
  }).catch(function (resp) {
    var _resp$message;
    if (resp.name === 'AbortError') {
      throw new Error("Request timed out --> " + url);
    }
    var error = new Error((_resp$message = resp.message) !== null && _resp$message !== void 0 ? _resp$message : '系统繁忙，请稍后再试');
    error.code = resp.code;
    error.result = resp.result;
    // 兼容老逻辑
    error.promptTitle = resp.promptTitle;
    error.promptMsg = resp.promptMsg;
    error.redirectUrl = resp.redirectUrl;
    error.response = resp;
    throw error;
  });
};
export default fetchBase;